import { useFeatureFlag } from '@/hooks/useFeatureFlags';

export function BetaConfidentialityOverlay() {
  const isBeta = useFeatureFlag('betaMode');

  if (!isBeta) return null;

  return (
    <>
      {/* Badge */}
      <div className="fixed top-2 left-2 z-[55] bg-muted/90 border border-border text-muted-foreground text-[10px] font-semibold uppercase tracking-widest px-2 py-0.5 rounded pointer-events-none select-none">
        Closed Beta
      </div>

      {/* Watermark overlay — purely decorative (aria-hidden); excluded from
          a11y contrast scans (WCAG 1.4.3 exempts pure-decoration text). */}
      <div
        className="fixed inset-0 z-[50] pointer-events-none select-none overflow-hidden"
        aria-hidden="true"
        data-testid="beta-confidential-overlay"
      >
        <div
          className="absolute inset-[-50%] flex flex-wrap items-center justify-center gap-32"
          style={{
            transform: 'rotate(-30deg)',
            opacity: 0.04,
          }}
        >
          {Array.from({ length: 30 }).map((_, i) => (
            <span
              key={i}
              className="text-foreground text-lg font-bold whitespace-nowrap"
              style={{ fontSize: '14px', letterSpacing: '0.15em' }}
            >
              OptiBay Closed Beta — Confidential
            </span>
          ))}
        </div>
      </div>
    </>
  );
}
